import { gridMedia } from '../../../../utils/grid-utils';

export const gridPageTitle = {
  gridColumn: gridMedia('1 / 12', '1 / 12'),
  gridRow: gridMedia('1', '1'),
};
